import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {finalize, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {ToastrService, GlobalConfig} from 'ngx-toastr';
import {Station} from "../../../models/Station";
import {Telephone} from "../../../models/telephone";
import {StationService} from "../../../services/station.service";
import {HeaderService} from "../../../services/header/header.service";
import {environment} from "../../../../environments/environment";
import {
    getConnectedEnterpriseNameFromUser,
    getEnterpriseStationIdFromUser,
    pickStationFromUser,
    setConnectedEnterpriseStationId,
} from "../../../services/enterprise-context";
import { ParametreNavService } from "../../../services/parametre/parametre-nav.service";

@Component({
    selector: 'app-profile-entreprise',
    templateUrl: './profile-entreprise.component.html',
    styleUrls: ['./profile-entreprise.component.scss'],

})
export class ProfileEntrepriseComponent implements OnInit {
    logoPreview: string | null = null;
    file_url = environment.url_images;


    private options: GlobalConfig;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    clientId = this.currentUser?.id;
    stationId = getEnterpriseStationIdFromUser(this.currentUser) || this.currentUser?.stations?.[0]?.id;

    constructor(
        private toastr: ToastrService,
        private stationService: StationService,
        private headerService: HeaderService,
        private readonly parametreNav: ParametreNavService,
        private readonly router: Router
    ) {
        this.options = this.toastr.toastrConfig;
    }

    data: any = {
        id: 0,
        client_id: 0,
        station_id: 0,
        logo: '',
        label: '',
        nom_entreprise: '',
        matricule_fiscale: '',
        site_web: '',
        prenom: '',
        nom: '',
        email: '',
        adresses: [{
            id: 0,
            pays: '',
            region: '',
            code_postal: '',
            adresse: '',
            station_id: 0
        }],
        telephones: [],
        tel : ''
    };

    dataError: {
        logo: string;
        label: string;
        nom_entreprise: string;
        adresses: {
            region: string;
            code_postal: string;
            adresse: string;
        }[];
        telephones: string[]; // for numero errors
        telephoneTypes: string[]; // NEW: for type errors
    } = {
        logo: '',
        label: '',
        nom_entreprise: '',
        adresses: [{region: '', code_postal: '', adresse: ''}],
        telephones: [],
        telephoneTypes: [], // Initialize new array
    };

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Profil de l\'entreprise',
            buttons: []
        });

        const defaultNomEntreprise = this.resolveDefaultNomEntreprise();
        if (defaultNomEntreprise) {
            this.data.nom_entreprise = defaultNomEntreprise;
            this.data.label = defaultNomEntreprise;
        }

        if (this.data.telephones.length === 0) {
            this.addTel();
        }

        const clientId = this.toPositiveId(this.clientId);
        if (!clientId && !this.stationId) {
            this.parametreNav.markPageReady();
            return;
        }

        // 1) Résoudre le vrai stations_user.id depuis back-erp
        // 2) Puis charger settings/station avec cet id
        const erpStations$ = clientId
            ? this.stationService.getStationsByClient(clientId)
            : of([] as any[]);

        erpStations$.pipe(
            switchMap((erpStations) => {
                const resolvedId = this.resolveErpStationId(erpStations);
                if (resolvedId > 0) {
                    this.stationId = resolvedId;
                    this.data.station_id = resolvedId;
                    this.data.client_id = clientId || this.toPositiveId(this.clientId);
                    setConnectedEnterpriseStationId(resolvedId, {
                        label: this.data.label || defaultNomEntreprise,
                        nom_entreprise: this.data.nom_entreprise || defaultNomEntreprise,
                    });
                    return this.stationService.getStation(resolvedId, clientId || undefined);
                }
                return of({ success: false, message: 'Station introuvable.' });
            }),
            finalize(() => this.parametreNav.markPageReady())
        ).subscribe({
            next: (res) => {
                console.log('🔍 [ProfileEntreprise] Réponse complète de l\'API GET:', res);
                console.log('🔍 [ProfileEntreprise] Station récupérée:', res.station);
                if (res.success && res.station) {
                    this.data = res.station;
                    // S'assurer que nom_entreprise est défini (inscription / création station)
                    if (!this.data.nom_entreprise?.trim()) {
                        this.data.nom_entreprise =
                            this.data.label?.trim() ||
                            defaultNomEntreprise ||
                            this.resolveDefaultNomEntreprise();
                    }
                    if (!this.data.label?.trim() && this.data.nom_entreprise) {
                        this.data.label = this.data.nom_entreprise;
                    }
                    console.log('🔍 [ProfileEntreprise] Données assignées à this.data:', this.data);
                    console.log('🔍 [ProfileEntreprise] Propriétés disponibles:', Object.keys(this.data));
                    
                    // Vérifier si prenom, nom, email sont dans coordonnees ou directement dans station
                    if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
                        const coordonnee = this.data.coordonnees[0];
                        console.log('🔍 [ProfileEntreprise] Coordonnées trouvées:', coordonnee);
                        this.data.prenom = coordonnee.prenom || '';
                        this.data.nom = coordonnee.nom || '';
                        this.data.email = coordonnee.email || '';
                    } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
                        // Si coordonnees est un objet unique
                        console.log('🔍 [ProfileEntreprise] Coordonnées (objet unique):', this.data.coordonnees);
                        this.data.prenom = this.data.coordonnees.prenom || '';
                        this.data.nom = this.data.coordonnees.nom || '';
                        this.data.email = this.data.coordonnees.email || '';
                    } else {
                        // Si les champs sont directement dans station
                        console.log('🔍 [ProfileEntreprise] Vérification des champs directs:');
                        console.log('  - prenom:', this.data.prenom);
                        console.log('  - nom:', this.data.nom);
                        console.log('  - email:', this.data.email);
                        // Initialiser si vides
                        this.data.prenom = this.data.prenom || '';
                        this.data.nom = this.data.nom || '';
                        this.data.email = this.data.email || '';
                    }
                    
                    console.log('🔍 [ProfileEntreprise] Valeurs finales - prenom:', this.data.prenom, 'nom:', this.data.nom, 'email:', this.data.email);

                    // Build full URL for existing logo
                    this.logoPreview = this.resolveLogoUrl(this.data.logo);
                   // console.log(this.data.logo);
                    // Ensure at least one address
                    if (!this.data.adresses || this.data.adresses.length === 0) {
                        this.data.adresses = [{
                            id: 0,
                            pays: '',
                            region: '',
                            code_postal: '',
                            adresse: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        // S'assurer que toutes les adresses ont station_id
                        this.data.adresses = this.data.adresses.map((adr: any) => ({
                            ...adr,
                            station_id: adr.station_id || this.data.station_id || this.data.id || 0
                        }));
                    }
                    console.log('🔍 [ProfileEntreprise] Adresses récupérées:', this.data.adresses);

                    // Ensure at least one telephone
                    if (!this.data.telephones || this.data.telephones.length === 0) {
                        this.data.telephones = [{
                            id: 0,
                            numero: '',
                            type: 'mobile',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        // S'assurer que tous les téléphones ont station_id
                        this.data.telephones = this.data.telephones.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || 'mobile'
                        }));
                    }
                    console.log('🔍 [ProfileEntreprise] Téléphones récupérés:', this.data.telephones);
                } else {
                    // Pas encore de fiche settings/stations → préparer un POST create
                    this.data.id = 0;
                    this.data.client_id = clientId || this.toPositiveId(this.clientId);
                    this.data.station_id = this.toPositiveId(this.stationId);
                    if (!this.data.nom_entreprise?.trim() && defaultNomEntreprise) {
                        this.data.nom_entreprise = defaultNomEntreprise;
                        this.data.label = defaultNomEntreprise;
                    }
                    console.warn('⚠️ [ProfileEntreprise] Station settings absente — mode création (POST), station_id ERP=', this.stationId);
                }
            },
            error: (err) => {
              //  console.error(err);
                this.data.client_id = clientId || this.toPositiveId(this.clientId);
                this.data.station_id = this.toPositiveId(this.stationId);
                this.toastr.error('Erreur de chargement de la station');
            }
        });

    }

    /**
     * ID à utiliser pour GET/PUT settings/station = stations_user.id (back-erp).
     */
    private resolveErpStationId(erpStations: any[]): number {
        const list = Array.isArray(erpStations) ? erpStations : [];
        const preferredLocal = this.toPositiveId(this.stationId);

        if (preferredLocal > 0) {
            const match = list.find((s) => this.toPositiveId(s?.id) === preferredLocal);
            if (match) {
                return preferredLocal;
            }
        }

        const connected = list.find(
            (s) => s && (s.isConnecte === 1 || s.isConnecte === true)
        );
        const fromConnected = this.toPositiveId(connected?.id);
        if (fromConnected > 0) {
            return fromConnected;
        }

        const fromFirst = this.toPositiveId(list[0]?.id);
        if (fromFirst > 0) {
            return fromFirst;
        }

        // Repli : id déjà connu localement (stations_user) si l'API client est vide
        return preferredLocal;
    }
    selectedLogoFile: File | null = null;
    onFileSelected(event: Event) {
        const file = (event.target as HTMLInputElement).files?.[0];
        this.dataError.logo = '';
        this.selectedLogoFile = null;
        if (file) {
            if (file.size > 3 * 1024 * 1024) {
                this.dataError.logo = 'Le fichier ne doit pas dépasser 3 Mo.';
                return;
            }
            this.selectedLogoFile = file;
            const reader = new FileReader();
            reader.onload = () => {
                this.logoPreview = reader.result as string; // preview before upload
            };
            reader.readAsDataURL(file);

            // upload to server
          /*  const formData = new FormData();
            formData.append('file', file);
            this.stationService.uploadFile(formData).subscribe({
                next: (res: any) => {
                    if (res?.path) {

                        this.data.logo = `${this.file_url}${res.path}`;
                    } else {
                        this.dataError.logo = 'Réponse du serveur invalide (champ "path" manquant).';
                    }
                },
                error: () => {
                  //  this.dataError.logo = 'Erreur lors du téléversement du fichier.';
                }
            });*/
        }
    }


    addTel(): void {
        if (this.data.telephones.length < 5) {
            const newTel: Telephone = {
                id: 0,
                numero: '',
                type: 'mobile',
                station_id: this.data.station_id || this.stationId || 0
            };
            this.data.telephones.push(newTel);
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 5 numéros de téléphone.");
        }
    }

    deleteTel(index: number): void {
        if (this.data.telephones.length > 1) {
            this.data.telephones.splice(index, 1);
        }
    }

    addAdress(): void {
        if (this.data.adresses.length < 5) {
            this.data.adresses.push({
                id: 0,
                pays: '',
                region: '',
                code_postal: '',
                adresse: '',
                station_id: this.data.station_id
            });
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 5 adresses.");
        }
    }

    deleteAdress(index: number): void {
        if (this.data.adresses.length > 1) {
            this.data.adresses.splice(index, 1);
        }
    }


    private resolveLogoUrl(logo: string | null | undefined): string | null {
        const raw = String(logo || '').trim();
        if (!raw) {
            return null;
        }
        if (/^https?:\/\//i.test(raw) || raw.startsWith('data:')) {
            return raw;
        }
        const base = String(this.file_url || '').replace(/\/$/, '');
        const path = raw.startsWith('/') ? raw : `/${raw}`;
        return `${base}${path}`;
    }

    toasterInfo(msg: string): void {
        this.toastr.info(msg, '', {
            positionClass: 'toast-bottom-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true
        });
    }


    submit(): void {
        this.dataError = {
            label: '',
            nom_entreprise: '',
            logo: '',
            adresses: this.data.adresses.map(() => ({region: '', code_postal: '', adresse: ''})),
            telephones: this.data.telephones.map(() => ''),
            telephoneTypes: this.data.telephones.map(() => ''), // New array initialized
        };

        let hasError = false;

        if (!this.data.nom_entreprise || !this.data.nom_entreprise.trim()) {
            this.dataError.nom_entreprise = "Le nom de l'entreprise est obligatoire";
            hasError = true;
        }

        this.data.adresses.forEach((adresse, index) => {
            // Only check required fields for the first address (as per original logic structure)
            if (index === 0) {
                if (!adresse.region || !adresse.region.trim()) {
                    this.dataError.adresses[index].region = "Région requise";
                    hasError = true;
                }
                if (!adresse.code_postal || !adresse.code_postal.trim()) {
                    this.dataError.adresses[index].code_postal = "Code postal requis";
                    hasError = true;
                }
                if (!adresse.adresse || !adresse.adresse.trim()) {
                    this.dataError.adresses[index].adresse = "Adresse requise";
                    hasError = true;
                }
            }
        });


        this.dataError.telephones = [];
        this.dataError.telephoneTypes = [];
        this.data.telephones.forEach((tel, i) => {
            this.dataError.telephones[i] = '';
            this.dataError.telephoneTypes[i] = '';
            const numeroStr = tel.numero != null ? String(tel.numero).trim() : '';
            if (!numeroStr) {
                this.dataError.telephones[i] = 'Numéro requis';
                hasError = true;
            }
            if (!tel.type || !String(tel.type).trim()) {
                // Défaut mobile si l'utilisateur n'a pas touché le select (ngModel resté '')
                tel.type = 'mobile';
            }
        });

        // ✅ Extra check: ensure logo has been uploaded
        if (!this.data.logo && !this.selectedLogoFile) {
            this.dataError.logo = 'Le logo est obligatoire.';
            hasError = true;
        }

        if (hasError) {
            this.toastr.error('Veuillez corriger les erreurs dans le formulaire.', 'Attention', {
                positionClass: 'toast-bottom-right',
              //  toastClass: 'toast ngx-toastr custom-error-toast',
            });
            return;
        }

        // Upload du logo si un fichier a été sélectionné
        if (this.selectedLogoFile) {
            const formData = new FormData();
            formData.append('file', this.selectedLogoFile);
            this.stationService.uploadFile(formData).subscribe({
                next: (res: any) => {
                    if (res?.path) {
                        this.data.logo = res.path; // Stocker seulement le chemin relatif
                        this.updateStationData();
                    } else {
                        this.dataError.logo = 'Réponse du serveur invalide (champ "path" manquant).';
                        this.toastr.error('Erreur lors du téléversement du logo.', '', {
                            positionClass: 'toast-bottom-right',
                        });
                    }
                },
                error: () => {
                    this.dataError.logo = 'Erreur lors du téléversement du fichier.';
                    this.toastr.error('Erreur lors du téléversement du logo.', '', {
                        positionClass: 'toast-bottom-right',
                    });
                }
            });
        } else {
            // Pas de nouveau logo, mettre à jour directement
            this.updateStationData();
        }
    }

    private toPositiveId(value: unknown): number {
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    }

    private updateStationData(): void {
        // Préparer le logo : si c'est une URL complète, extraire seulement le chemin relatif
        let logoPath = this.data.logo || '';
        if (logoPath && this.file_url && logoPath.includes(this.file_url)) {
            logoPath = logoPath.replace(this.file_url, '');
        }

        const clientId = this.toPositiveId(this.data.client_id) || this.toPositiveId(this.clientId);
        const stationFk = this.toPositiveId(this.data.station_id) || this.toPositiveId(this.stationId);
        const stationPk = this.toPositiveId(this.data.id);

        if (!clientId || !stationFk) {
            this.toastr.error(
                'Impossible d’enregistrer : identifiants client / station manquants. Reconnectez-vous.',
                '',
                { positionClass: 'toast-bottom-right' }
            );
            return;
        }

        // Préparer les téléphones (type par défaut mobile — le select peut laisser type='')
        const telephonesToSend = this.data.telephones
            .filter((tel: any) => tel.numero != null && String(tel.numero).trim())
            .map((tel: any) => ({
                id: this.toPositiveId(tel.id) || 0,
                numero: String(tel.numero).trim(),
                type: (tel.type && String(tel.type).trim()) || 'mobile',
                station_id: stationPk || stationFk
            }));

        let coordonneeId = 0;
        if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
            coordonneeId = this.toPositiveId(this.data.coordonnees[0].id);
        } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
            coordonneeId = this.toPositiveId(this.data.coordonnees.id);
        }

        const stationData: any = {
            client_id: clientId,
            station_id: stationFk,
            logo: logoPath,
            label: this.data.label || this.data.nom_entreprise || '',
            nom_entreprise: this.data.nom_entreprise || this.data.label || '',
            matricule_fiscale: this.data.matricule_fiscale || '',
            site_web: this.data.site_web || '',
            adresses: this.data.adresses.map((adr: any) => ({
                id: this.toPositiveId(adr.id) || 0,
                pays: adr.pays || '',
                region: adr.region || '',
                code_postal: adr.code_postal || '',
                adresse: adr.adresse || '',
                station_id: stationPk || stationFk
            })),
            telephones: telephonesToSend,
            // Toujours envoyer des coordonnées (obligatoire à la création côté API)
            coordonnees: [{
                id: coordonneeId,
                prenom: this.data.prenom || '',
                nom: this.data.nom || '',
                email: this.data.email || '',
                station_id: stationFk,
                telephones: telephonesToSend
            }]
        };

        if (stationPk) {
            stationData.id = stationPk;
        }

        const isCreate = !stationPk;
        const request$ = isCreate
            ? this.stationService.addStation(stationData)
            : this.stationService.updateStation(stationPk || stationFk, stationData);

        request$.subscribe({
            next: (res) => {
                console.log(`✅ [ProfileEntreprise] Réponse ${isCreate ? 'POST' : 'PUT'}:`, res);
                if (!res?.success) {
                    this.toastr.error(res?.message || 'Échec de l’enregistrement', '', {
                        positionClass: 'toast-bottom-right',
                        toastClass: 'toast ngx-toastr custom-error-toast',
                    });
                    return;
                }
                this.toastr.success(
                    isCreate ? 'Entreprise enregistrée avec succès !' : 'Modification enregistrée avec succès !',
                    '',
                    {
                        positionClass: 'toast-bottom-right',
                        toastClass: 'toast ngx-toastr custom-success-toast',
                    }
                );
                const onboardingEntreprise = localStorage.getItem('registration_nom_entreprise');
                if (isCreate && onboardingEntreprise) {
                    localStorage.removeItem('registration_nom_entreprise');
                    void this.router.navigate(['/home']);
                    return;
                }
                if (res.station) {
                    this.data = res.station;
                    
                    // Récupérer les coordonnées après la mise à jour
                    let telephonesFromCoordonnees: any[] = [];
                    if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
                        const coordonnee = this.data.coordonnees[0];
                        this.data.prenom = coordonnee.prenom || '';
                        this.data.nom = coordonnee.nom || '';
                        this.data.email = coordonnee.email || '';
                        // Récupérer les téléphones depuis coordonnees
                        if (coordonnee.telephones && Array.isArray(coordonnee.telephones) && coordonnee.telephones.length > 0) {
                            telephonesFromCoordonnees = coordonnee.telephones;
                            console.log('✅ [ProfileEntreprise] Téléphones récupérés depuis coordonnées après PUT:', telephonesFromCoordonnees);
                        }
                    } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
                        this.data.prenom = this.data.coordonnees.prenom || '';
                        this.data.nom = this.data.coordonnees.nom || '';
                        this.data.email = this.data.coordonnees.email || '';
                        if (this.data.coordonnees.telephones && Array.isArray(this.data.coordonnees.telephones)) {
                            telephonesFromCoordonnees = this.data.coordonnees.telephones;
                        }
                    }
                    
                    // Utiliser les téléphones de coordonnees ou ceux de la station
                    if (telephonesFromCoordonnees.length > 0) {
                        this.data.telephones = telephonesFromCoordonnees.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || ''
                        }));
                    } else if (!this.data.telephones || this.data.telephones.length === 0) {
                        this.data.telephones = [{
                            id: 0,
                            numero: '',
                            type: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        this.data.telephones = this.data.telephones.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || ''
                        }));
                    }
                    console.log('✅ [ProfileEntreprise] Téléphones finaux après rechargement:', this.data.telephones);
                    
                    // S'assurer que les adresses sont correctement initialisées
                    if (!this.data.adresses || this.data.adresses.length === 0) {
                        this.data.adresses = [{
                            id: 0,
                            pays: '',
                            region: '',
                            code_postal: '',
                            adresse: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        this.data.adresses = this.data.adresses.map((adr: any) => ({
                            ...adr,
                            station_id: adr.station_id || this.data.station_id || this.data.id || 0
                        }));
                    }
                    
                    console.log('✅ [ProfileEntreprise] Données rechargées après PUT:', this.data);
                    console.log('✅ [ProfileEntreprise] Téléphones rechargés:', this.data.telephones);
                    
                    this.logoPreview = this.resolveLogoUrl(this.data.logo);
                }
            },
            error: (err) => {
                const msg = typeof err === 'string' ? err : (err?.message || 'Échec de l’enregistrement');
                this.toastr.error(msg, '', {
                    positionClass: 'toast-bottom-right',
                    toastClass: 'toast ngx-toastr custom-error-toast',
                });
                console.error('Erreur mise à jour station:', err);
            }
        });
    }
    clearFieldError(fieldName: string): void {
        if (this.dataError[fieldName]) {
            this.dataError[fieldName] = '';
        }
    }

    /** Nom saisi à la création d'entreprise (étape inscription / create-station). */
    private resolveDefaultNomEntreprise(): string {
        try {
            const raw = localStorage.getItem('currentUser');
            if (raw) {
                const user = JSON.parse(raw);
                const fromUser = getConnectedEnterpriseNameFromUser(user);
                if (fromUser) {
                    return fromUser;
                }
                const station = pickStationFromUser(user);
                const fromLabel = String(station?.['label'] ?? '').trim();
                if (fromLabel) {
                    return fromLabel;
                }
            }
            const pending = localStorage.getItem('registration_nom_entreprise');
            return String(pending ?? '').trim();
        } catch {
            return '';
        }
    }
    clearAddressFieldError(index: number, field: 'region' | 'code_postal' | 'adresse') {
        this.dataError.adresses[index][field] = '';
    }

    onPhoneInput(event: any, index: number) {
        const input = event.target;
        const value = input.value;

        // Clear previous error
        this.clearPhoneError(index);

        // Validate phone number
        this.validatePhoneNumber(value, index);
    }

    validatePhoneNumber(phoneNumber: string, index: number) {
        // Remove any non-digit characters
        const cleanNumber = phoneNumber.replace(/\D/g, '');

        // Check if empty
        if (!cleanNumber) {
            this.dataError.telephones[index] = 'Le numéro de téléphone est requis';
            return false;
        }

        // Check if exactly 8 digits
        if (cleanNumber.length !== 8) {
            this.dataError.telephones[index] = 'Le numéro doit contenir exactement 8 chiffres';
            return false;
        }

        // Check if starts with valid Tunisian prefix (optional)
        const validPrefixes = ['2', '4', '5', '7', '9'];
        if (!validPrefixes.includes(cleanNumber.charAt(0))) {
            this.dataError.telephones[index] = 'Numéro de téléphone invalide';
            return false;
        }

        // Clear error if valid
        this.dataError.telephones[index] = '';
        return true;
    }

    clearPhoneError(index: number) {
        if (this.dataError.telephones[index]) {
            this.dataError.telephones[index] = '';
        }
    }

// Alternative: Use reactive forms for better validation
    validatePhoneOnSubmit() {
        this.data.telephones.forEach((tel, index) => {
            if (!tel.numero) {
                this.dataError.telephones[index] = 'Le numéro de téléphone est requis';
            } else if (tel.numero.toString().length !== 8) {
                this.dataError.telephones[index] = 'Le numéro doit contenir exactement 8 chiffres';
            } else if (tel.numero < 0) {
                this.dataError.telephones[index] = 'Le numéro ne peut pas être négatif';
            } else {
                this.dataError.telephones[index] = '';
            }
        });
    }

}
